import { render, staticRenderFns } from "./TablaInscripcionesCompletasConsolidadas.vue?vue&type=template&id=700ced97"
import script from "./TablaInscripcionesCompletasConsolidadas.vue?vue&type=script&lang=js"
export * from "./TablaInscripcionesCompletasConsolidadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports